import { createMergeReducer } from '../utils/reducer'

export type TitleIdToFormattedOffer = {
  [titleId: string]: string | undefined
}

export const reducer = createMergeReducer(
  t => t.formattedOfferAvailableOn,
  {} as TitleIdToFormattedOffer
)
